import { styled } from "@mui/material/styles";

// Components
import { NavLink } from "react-router-dom";
import { Card, List, SvgIcon, Typography } from "@mui/material";

// Themes
import theme from "../Theme";

const styledName = "SideMenu";

const menuItemStyles = {
  "&": {
    width: "230px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    padding: "0 25px",
    margin: "10px 0",
    borderRadius: "10px",
    textDecoration: "none",
    transition: "background-color 0.3s ease-in-out",
    ":hover": {
      backgroundColor: theme.palette.background.default,
    },
  },
};

const svgIconStyles = {
  "&": {
    color: theme.palette.grey[500],
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
};

export const StyledMenuWrapper = styled(Card, { name: styledName })({
  "&": {
    width: "280px",
    minWidth: "280px",
    height: "100vh",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
});

export const StyledMainMenu = styled(List, { name: styledName })({
  "&": {
    flexGrow: 1,
  },
});

export const StyledMenuItem = styled(NavLink, { name: styledName })({
  "&": {
    ...menuItemStyles,
    color: theme.palette.primary.main,
    "&.active": {
      color: "white",
      backgroundColor: theme.palette.primary.main,
    },
  },
});

export const StyledMenuIcon = styled(SvgIcon, { name: styledName })({
  "&": {
    fontSize: "3rem",
  },
});

export const StyledMenuLabel = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.6rem",
    marginLeft: "2.5rem",
  },
});

export const StyledLogoutMenu = styled("div", { name: styledName })({
  "&": {
    ...menuItemStyles,
    color: theme.palette.error.main,
    cursor: "pointer",
  },
});

// User Info
export const StyledUserWrapper = styled("div", { name: styledName })({
  "&": {
    height: "80px",
    minHeight: "80px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    justifyContent: "space-between",
  },
});

export const StyledUserInfo = styled("div", { name: styledName })({
  "&": {
    width: "200px",
    height: "40px",
    borderRadius: "20px",
    backgroundColor: theme.palette.background.default,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px 0 6px",
  },
});

export const StyledUserAvatar = styled("img", { name: styledName })({
  "&": {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    border: `solid 1px ${theme.palette.primary.main}`,
  },
});

export const StyledDropdown = styled(SvgIcon, { name: styledName })({
  "&": {
    ...svgIconStyles,
    transform: `translate(0,-20%)`,
  },
});
